module.exports = __webpack_public_path__ + "img/logoo.97ab9931.png";